import { WorkOrderTable } from "@/app/ProDrivers/WorkOrders/Components/WorkOrderTable";
import { useNavigate, useSearch } from "@tanstack/react-router";

export function WorkOrdersTableScreen() {
  const { workOrderStatus } = useSearch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/pro-drivers/work-orders/",
  });

  const navigate = useNavigate();

  return (
    <WorkOrderTable
      status={workOrderStatus ?? []}
      setStatus={(status) => {
        navigate({
          from: "/$tenant/$orgId/supplier/{-$supplierId}",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/pro-drivers/work-orders",
          params: (prev) => prev,
          search: {
            workOrderStatus: status,
          },
        });
      }}
    />
  );
}
